import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pedestrian: 0,
  auto: 0,
  transit: 0,
  bicycle: 0,
  freight: 0
}

const finalScores = createSlice({
  name: 'finalScores',
  initialState,
  reducers: {
    setFinalScores(state, action) {
      const { field, value } = action.payload
      state[field] = value
    }
  }
})

export const { setFinalScores } = finalScores.actions
export default finalScores.reducer
